<template lang="html">
  <div class="app-header">
    <div class="app-header-center">
      <!-- <img class="app-header-logo" src="../../assets/logo.png" /> -->
      <palta-icon name="envone" size="big" />
    </div>
  </div>
</template>

<script>
import '@palta-ui/icon/src/icons/envone';

import PaltaIcon from '@palta-ui/icon';

export default {
  components: {
    PaltaIcon,
  },
}
</script>

<style lang="stylus">
.app-header {
  position: absolute;
  top: -100px;
  left: 0;
  right: 0;
  height: 100px;
  z-index: 1;

  display: flex;
  height: 88px;

  .app-header-center {
    justify-content: center;
    align-items: center;
    display: flex;
    flex: 1;

    .app-header-logo {
      width: 20px;
    }
  }

}
</style>
